var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbout1Icon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6666 28L40.313 29.5158C40.6714 29.868 40.8506 30.0442 40.7876 30.1938C40.7244 30.3434 40.471 30.3434 39.9642 30.3434H33.7554C30.5768 30.3434 28 32.876 28 36C28 36.7042 28.131 37.3782 28.37 38M33.3334 44L31.687 42.4842C31.3286 42.132 31.1494 41.9558 31.2124 41.8062C31.2756 41.6566 31.529 41.6566 32.0358 41.6566H38.2446C41.4232 41.6566 44 39.124 44 36C44 35.2958 43.869 34.6218 43.63 34",
    stroke: "#5A65F5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9826 23C44 21.7986 44 21.471 44 20C44 12.4575 44 8.6863 41.6568 6.34314C39.3138 4 35.5424 4 28 4H20C12.4575 4 8.6863 4 6.34314 6.34314C4 8.6863 4 12.4575 4 20C4 27.5424 4 31.3138 6.34314 33.6568C8.6863 36 12.4575 36 20 36H22",
    stroke: "#5A65F5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9999 20H36.9819",
    stroke: "#5A65F5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 20H10.9819",
    stroke: "#5A65F5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29 20C29 22.7614 26.7614 25 24 25C21.2386 25 19 22.7614 19 20C19 17.2386 21.2386 15 24 15C26.7614 15 29 17.2386 29 20Z",
    stroke: "#5A65F5",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout1Icon1);
export default __webpack_public_path__ + "static/media/about1-icon1.f4b4e33f86ff8d3a6ef531b1efcdf3fa.svg";
export { ForwardRef as ReactComponent };